<script setup>
    import { ref, watch, computed, onMounted, getCurrentInstance } from 'vue'
    import { useRouter } from 'vue-router';
    import {usePageLoadingStore} from "../../../../stores/pageLoading";
    import SNBAdmin from '../../../../layouts/nav/SNBAdmin.vue'
    import { useAlertStore } from '../../../../stores/alertStore';
    import curriculumService from '../../services/curriculum/curriculumService';
    import _ from 'lodash'
    const { $toast, $pageListBoardNo, $gbNameKR } = getCurrentInstance().appContext.config.globalProperties;
    const { $alert, $confirm } = useAlertStore();
    const loadingStore = usePageLoadingStore();
    const router = useRouter();

    const list = ref([]);
    const currentPage = ref(1);
    const pageSize = ref(10);
    const totalPages = ref(0);
    const totalCount = ref(0);
    const orderDirection = ref('ASC');
    const ascable = ref(true);

    const selectedStatus = ref('');

    const pageSizeGroup = ref([
        { label:"10개씩 보기", value: "10" },
        { label:"30개씩 보기", value: "30" },
        { label:"50개씩 보기", value: "50" },   
        { label:"100개씩 보기", value: "100" },   
    ]);

    onMounted(()=>{
        retrieveList();
    });

    let disabledWatchIsSelectedAll = false;
    let disabledWatchList = false;

    const isSelectedAll= ref(false);
    watch(isSelectedAll, (newValue)=>{
        if(!disabledWatchIsSelectedAll) {
            const newList = _.cloneDeep(list.value);
            _.each(newList, (el)=>{
                el.checked = newValue;
            });
            disabledWatchList = true;
            list.value = newList;
        } else {
            disabledWatchIsSelectedAll = false;
        }
    })

    watch(list, (newValue)=>{
        if(!disabledWatchList) {
            const checkedList = _.filter(newValue, { checked: true});
            if(checkedList.length === newValue.length) {
                disabledWatchIsSelectedAll = true;
                isSelectedAll.value = true;
            } else {
                if(isSelectedAll.value) {
                    disabledWatchIsSelectedAll = true;
                    isSelectedAll.value = false;
                }
            }
        } else {
            disabledWatchList = false;
        }
    }, { deep: true})

    const retrieveList = () => {
        let paramObj = {
            pageNo: currentPage.value || 1,
            size: pageSize.value || 10,
        };

        loadingStore.loading = true;
        curriculumService.retrieveAllCurriculumPaging(paramObj)
            .then( async (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    // list.value = _.orderBy(result, 'order');
                    // totalCount.value = res.data.result.totalElements;
                    totalPages.value = result.totalPages;
                    totalCount.value = result.totalElements;
                    list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
                } else {
                }
            }).catch( (error) =>  {
            // console.log(error);
            loadingStore.loading = false;
        });
    }

    const onClickNew = async () => {
       router.push({ name: 'SiteCurriculumCreate' });
    };

    const onSelectStatus = async (index) => {
        selectedStatus.value = index === 0 ? 'Y' : 'N';
        const checkedList =_.filter(list.value, { checked: true});
        // console.log(checkedList);

        if(checkedList.length === 0) {
            $alert("상태를 변경할 총괄표를 선택하세요.");
            return;
        } 
        
        if(selectedStatus.value === 'Y' && checkedList.length > 1) {
            $alert("총괄표는 1개만 '공개'할 수 있습니다.");
            return;
        }

        const ok = await $confirm(`선택한 총괄표를 ${selectedStatus.value === 'Y' ? "'공개'" : "'비공개'"}로 변경하시겠습니까?`, "변경", "취소");
        // let promiseList = [];


        if(ok) {
            const summaryIds = _.map(checkedList, (el)=>el.summaryId);
            let result;
            if(selectedStatus.value === 'Y') {
                result = curriculumService.updateCurriculumOpenYnY(summaryIds);
            } else {
                result = curriculumService.updateCurriculumOpenYnN(summaryIds);
            }

            result.then((res) => {
                    $alert("변경되었습니다.");
                    retrieveList();
                })
                .catch( (error) =>  {
                    $alert(error);
                });
        }
    };

    const onSelectPage = (pageNo) => {
        currentPage.value = pageNo;
        retrieveList();
    };

    const onSelectPageSize = (option) => {
        pageSize.value = option.value;
        currentPage.value = 1;
        retrieveList();
    };

    const onClickDetail = (summaryId) => {
        router.push({ name: 'SiteCurriculumDetail', params: { id: summaryId }});
    };
</script>

<template>
    <div class="content">
        <div class="sub-title">
            <h3>총괄표 관리</h3>
        </div>
        <div class="btn-wrap space-between mb-xs">
            <div class="flex-wrap" style="gap: 10px;">
                <KSASecondaryButton text="총괄표 등록" @click="onClickNew" style="width: 150px;" />
                <KSADropdownButton class="gray_button ml-xs" text="상태 변경" :options="['공개', '비공개']" @click="onSelectStatus" />
            </div>
        </div>
            <div class="list-top">
            <p>전체 <span>{{ totalCount }}</span>개</p>
            <div>
                <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
            </div>
        </div>
        <div class="table-form">
            <table class="horizontal">
                <tr>
                    <th width="5%"><KSACheckBox v-model="isSelectedAll" /></th>
                    <th width="5%">NO</th>
                    <th width="5%">상태</th>
                    <th>총괄표명</th>
                    <th width="10%">작성자</th>
                    <th width="10%">아이디</th>
                    <th width="15%">최근 수정일</th>
                    <th width="15%">최초 등록일</th>
                </tr>
                <tr v-if="list.length > 0" v-for="(item, index) in list">
                    <td><KSACheckBox v-model="item.checked" /></td>
                    <td>{{ item.boardNo}}</td>
                    <td>{{ item.summaryOpenYn === 'Y' ? '공개' : '비공개' }}</td>
                    <td class="title text-left">
                        <KSATextButton class="text-over" :text="item.summaryName" @click="onClickDetail(item.summaryId)" />
                    </td>
                    <td>{{ item.userName }}</td>
                    <td>{{ item.userLoginId }}</td>
                    <td>{{ $yyyymmddHHmmss(item.modifyDate) }}</td>
                    <td>{{ $yyyymmddHHmmss(item.createDate) }}</td>
                </tr>
                <tr v-if="list.length === 0">
                    <td colspan="8">등록된 총괄표가 없습니다.</td>
                </tr>
            </table>
        </div>
            <Paginate
            v-if="list.length > 0"
            v-model="currentPage"
            :page-count="totalPages"
            :click-handler="onSelectPage"
        />
    </div>
</template>

<style lang="scss" scoped>
    @import "../../../../assets/scss/theme";

    .img {
        width: 400px;
        height: 160px;
    }

    td.title {
      max-width: 0;
    }

</style>
